module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/bot_chat.bc008331.png";